"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactRedux = require("react-redux");

var _react = require("react");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _fiverReactUiComponents = require("fiver-react-ui-components");

var _actions = require("../actions");

var _BetbarMiddleApproved = _interopRequireDefault(require("./BetbarMiddleApproved"));

var _BetbarMiddleInPlayCompleted = _interopRequireDefault(require("./BetbarMiddleInPlayCompleted"));

var _shared = require("./shared");

var _jsxRuntime = require("react/jsx-runtime");

var _templateObject, _templateObject2;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledMiddle = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  overflow: hidden;\n  max-height: ", ";\n  transition: max-height 0.35s;\n"])), function (p) {
  return p.isActive ? "600px" : "0";
});

var StyledRowRight = _styledComponents.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  flex: 1 1 auto;\n  color: ", ";\n"])), function (p) {
  return p.isActive ? p.theme.colorDarkText : p.theme.colorText;
});

var Wrapper = function Wrapper(_ref) {
  var history = _ref.history,
      setContest = _ref.setContest,
      getLeaderboard = _ref.getLeaderboard,
      isActive = _ref.isActive,
      setBetsOpen = _ref.setBetsOpen,
      setBetbarParent = _ref.setBetbarParent;
  var dispatch = (0, _reactRedux.useDispatch)();

  var _useState = (0, _react.useState)(),
      _useState2 = _slicedToArray(_useState, 2),
      activeRow = _useState2[0],
      setActiveRow = _useState2[1];

  var _useState3 = (0, _react.useState)(),
      _useState4 = _slicedToArray(_useState3, 2),
      isPlacingPaidBet = _useState4[0],
      setPlacingPaidBet = _useState4[1]; // const { showAffiliateBanners } = useSelector((s) => s.app);


  var _useSelector = (0, _reactRedux.useSelector)(function (s) {
    return s.betbar;
  }),
      activePickemList = _useSelector.activePickemList,
      activePickem = _useSelector.activePickem,
      activeBet = _useSelector.activeBet,
      isActivePickemInPlay = _useSelector.isActivePickemInPlay,
      isActivePickemCompleted = _useSelector.isActivePickemCompleted;

  var handleEnterClicked = function handleEnterClicked(e, index, activePickem, isSubsequentPaidPicks) {
    window.scrollTo(0, 0);
    console.log("handleEnterClicked", activePickem);
    e.stopPropagation();
    dispatch((0, _actions.setBetbar)({
      isBetsOpen: false,
      activePickem: activePickem,
      activeBet: undefined,
      isActivePickemInPlay: (activePickem === null || activePickem === void 0 ? void 0 : activePickem.status) === "IN_PLAY",
      isActivePickemCompleted: (activePickem === null || activePickem === void 0 ? void 0 : activePickem.status) === "COMPLETED",
      isActivePickemApproved: (activePickem === null || activePickem === void 0 ? void 0 : activePickem.status) === "APPROVED"
    }, setBetbarParent));
    setPlacingPaidBet(true); // setActiveRow(index);

    console.log("activeRow", activeRow);
    history.push("/lobby");

    if (isSubsequentPaidPicks) {
      dispatch(setContest({
        picks: []
      }));
    }
  };

  var handleCancelClicked = function handleCancelClicked() {
    console.log("handleCancelClicked");
    setActiveRow(undefined);
    setPlacingPaidBet(false);
  };

  var handleRowClicked = function handleRowClicked(pickem) {
    window.scrollTo(0, 0); // if (pickem?.activeBet) {

    getLeaderboard(pickem, pickem === null || pickem === void 0 ? void 0 : pickem.activeBet, true, true);
    dispatch((0, _actions.setBetbar)({
      activePickem: pickem,
      activeBet: pickem === null || pickem === void 0 ? void 0 : pickem.activeBet,
      isActivePickemInPlay: (pickem === null || pickem === void 0 ? void 0 : pickem.status) === "IN_PLAY",
      isActivePickemCompleted: (pickem === null || pickem === void 0 ? void 0 : pickem.status) === "COMPLETED",
      isActivePickemApproved: (pickem === null || pickem === void 0 ? void 0 : pickem.status) === "APPROVED",
      hadBet: pickem !== null && pickem !== void 0 && pickem.activeBet ? true : false
    }, setBetbarParent)); // }
  };

  var isInPlayOrCompleted = isActivePickemInPlay || isActivePickemCompleted; // const indexToShowBanner = Math.round(activePickemList?.length / 2);

  return /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledMiddle, {
    isActive: isActive,
    children: activePickemList === null || activePickemList === void 0 ? void 0 : activePickemList.map(function (pickem, index) {
      var _activePickem$activeB, _pickem$activeBet;

      var isActive = (activePickem === null || activePickem === void 0 ? void 0 : activePickem.id) === (pickem === null || pickem === void 0 ? void 0 : pickem.id) && (activePickem === null || activePickem === void 0 ? void 0 : (_activePickem$activeB = activePickem.activeBet) === null || _activePickem$activeB === void 0 ? void 0 : _activePickem$activeB.betId) === (pickem === null || pickem === void 0 ? void 0 : (_pickem$activeBet = pickem.activeBet) === null || _pickem$activeBet === void 0 ? void 0 : _pickem$activeBet.betId);
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_shared.Row, {
          isActive: isActive,
          onClick: function onClick() {
            return handleRowClicked(pickem);
          },
          children: (pickem === null || pickem === void 0 ? void 0 : pickem.status) !== "APPROVED" ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_BetbarMiddleInPlayCompleted.default, {
            pickem: pickem,
            isActive: isActive,
            handleRowClicked: handleRowClicked
          }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_BetbarMiddleApproved.default, {
            pickem: pickem,
            isActive: isActive,
            handleEnterClicked: handleEnterClicked,
            handleRowClicked: handleRowClicked,
            index: index
          })
        })
      });
    })
  });
};

var _default = Wrapper;
exports.default = _default;